export class SimpleEngineerBeanModel {
    public id: number;
    public name: string;
    public signature_base64: string;
    public operatorCod;

    [x: string]: any;
}
